import React, { useState,useEffect } from 'react';
import Bottom_menu from './Bottom_menu';
import { comma,instance,formatDate } from './common';
import TopTitle from './TopTitle';


function totalPrice(data){
    let price = 0;
    data.forEach(function(v){
        
        price += Number(v.jungsan_price)

    });
    
    return comma(price);
}

function Maechul({history}){
    
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    let now = new Date();
    let f_date = new Date(now.getFullYear(), now.getMonth(), 1);
    let l_date = new Date(now.getFullYear(), now.getMonth()+1, 0);
    

    const [data, setData] = useState({
        total:[],
        week:[],
        month:[],
    });

    const {total,week,month,online,offline} = data

    useEffect(() => {
        let obj = {
            si_id: si_id,
            f_date:formatDate(f_date),
            l_date:formatDate(l_date),
        }

        const fetchData = async () => {
            instance.post('/reserve/v2/maechul', obj).then(function (res) {
                console.log('res : ', res.data)
                setData(res.data);
            });

        };
        fetchData();
    }, []);

    console.log('month : ', month)
    
    return (
        <>
        <div className="container">
            <TopTitle title="정산현황"/>
            <div className="row p-0">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="h4 text-primary font-weight-bold">총 정산</th>
                            <th className="text-primary text-right"> {totalPrice(total)} 원</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>이번주 정산</th>
                            <td className="text-right">{totalPrice(week)} 원</td>
                        </tr>
                        <tr>
                            <th>당월 정산</th>
                            <td className="text-right"> {totalPrice(month)} 원</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        {/* <tr>
                            <th>현장 결제</th>
                            <td className="text-right"> {totalPrice(offline)} 원</td>
                        </tr>
                        <tr>
                            <th>앱 결제</th>
                            <td className="text-right"> {totalPrice(online)} 원</td>
                        </tr> */}
                    </tfoot>
                </table>
            </div>
            <div className="row p-0 mt-5">
                <div className="col">
                    <div className="btn btn-outline-secondary pt-3 pb-3 d-block" onClick={() => history.push('/maechul-list')}>정산 리스트</div>
                </div>
                {/* <div className="col">
                    <div className="btn btn-primary pt-3 pb-3 d-block" onClick={() => history.push('/jungsan')}>정산관리</div>
                </div>
                 */}
            </div>
        </div>
        <Bottom_menu />
        </>
    )
}

export default Maechul;